import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(theme => ({
  paper: {
    overflow: 'auto',
    ...theme.scrollbarStyles
  },
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    overflow: 'auto',
    ...theme.scrollbarStyles
  },
  dialogTitle: {
    color: theme.palette.blue_300.main
  },
  contentDialogTitle: {
    display: 'flex',
    // justifyContent: 'space-between',
    alignItems: 'center',
    gap: '16px'
  },
  contentDialogInfo: {
    width: '500px',
    display: 'flex',
    alignItems: 'flex-end',
    gap: '8px',
  },
  chipInfo: {
    backgroundColor: theme.palette.blue_300.main,
    color: theme.palette.white_100.main,
    padding: '0 12px',
    borderRadius: '8px',
    display: 'flex',
    alignItems: 'center',
    gap: '2px',
    height: '35px'
  },
  dialogContent: {
    display: 'flex',
    flexDirection: 'column',
    overflowY: 'auto',
    ...theme.scrollbarStyles
  },
  boxContent: {
    display: 'flex',
    gap: '8px'
  },
  formWrapper: {
    display: 'flex',
    gap: '16px',
    alignItems: 'flex-start'
  },
  formBox: {
    width: '100%',
    height: '100%',
    flex: 1 // Permite que o formulário ocupe o espaço restante
  },

  view: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: 350,
    minWidth: 350,
    flex: 'none',
    position: 'relative',
    marginTop: '10px',
  },
  mockup: {
    width: 260, // Tamanho fixo da imagem
    position: 'relative',
    zIndex: 1
  },
  buttons: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    gap: '6px',
    padding: '0 8px !important',
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main
  },
  textField: {
    marginRight: theme.spacing(1),
    flex: 1
  },

  btnWrapper: {
    position: 'relative'
  },

  buttonProgress: {
    color: theme.palette.green_200.main,
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120
  },
  colorAdorment: {
    width: 20,
    height: 20
  },

  // Ajustes no posicionamento do texto dentro do mockup
  viewRealTime: {
    position: 'absolute', // Novo: Posiciona o wrapper de texto dentro do 'view'
    width: 350,
    height: '100%',
    top: 0,
    left: 0,
    zIndex: 2,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-start',
    paddingTop: 100
  },
  viewRealTimeBox: {
    position: 'relative',
    padding: '8px 12px',
    width: '210px',
    maxWidth: '210px',
    wordWrap: 'break-word',
    borderRadius: '16px',
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    backgroundColor: theme.palette.white_100.main,
    color: theme.palette.gray_400.main
  },
  viewRealTimeTitle: {
    fontWeight: 600
  },
  timeStamp: {
    alignSelf: 'flex-end',
    fontSize: '0.75rem',
    color: theme.palette.gray_300.main
  },

  badgeVariableContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '2px',
    marginTop: '8px'
  },
  badgeVariable: {
    padding: '8px 0px',
    height: '15px',
    borderRadius: '4px',
    fontSize: '.8rem',
    background: 'transparent',
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main,
    border:
      theme.palette.type === 'dark'
        ? '1px solid' + theme.palette.dark_stroke.main
        : '1px solid' + theme.palette.gray_stroke.main,
    '&:hover': {
      background: 'transparent',
      borderColor: theme.palette.blue_300.main
    }
  },

  accordion: {
    backgroundColor: 'transparent',
    border: 'none',
    margin: `0px !important`,
    padding: '0px',
    '&::before': {
      display: 'none'
    }
  },

  accordionSummary: {
    minHeight: '12px !important',
    padding: '0 8px 0 0',
    '& .MuiAccordionSummary-content': {
      margin: '0'
    },
    '& .MuiIconButton-root': {
      padding: '4px',
      marginRight: '0px'
    },
    '&.MuiAccordionSummary-root': {
      flexDirection: 'row-reverse',
      padding: '0'
    },
    '& svg': {
      color:
        theme.palette.type === 'dark'
          ? theme.palette.dark_50.main
          : theme.palette.gray_400.main
    }
  },

  accordionDetails: {
    padding: '2px 0 8px 0',
    display: 'flex',
    flexWrap: 'wrap'
  },

  heading: {
    fontSize: '.8rem',
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main
  },

  chipVariableTags: {
    backgroundColor: theme.palette.blue_300.main,
    color: theme.palette.white_100.main,
    padding: '0',
    borderRadius: '4px',
    margin: '2px',
    '& .MuiChip-label ': {
      textTransform: 'capitalize',
      fontWeight: 500,
      fontSize: '.875rem'
    }
  },
  dialogActions: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  actionsContainer: {
    display: 'flex',
    gap: '8px',
    alignItems: 'center',
    justifyContent: 'flex-end',
    width: '100%'
  },
  buttonDeleteBot: {
    color: theme.palette.red_100.main,
    height: 35,
    width: 50,
    borderRadius: 8,
    '&:hover': {
      backgroundColor: theme.palette.red_100.main,
      color: theme.palette.white_100.main
    }
  },

  spacing: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px'
    // height: '100%'
  },
  label: {
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main,
    fontSize: '1rem'
  },
 

  // =========================================================================
  // ## Anexos (Attachments) e Pré-visualização
  // =========================================================================



  // =========================================================================
  // ## Botões (Apenas os relacionados ao anexo)
  // =========================================================================

  buttonFile: {
    '& .MuiButton-label': {
      display: 'flex',
      gap: '8px'
    },
    backgroundColor: theme.palette.blue_300.main,
    color: theme.palette.white_100.main,
    height: 35,
    borderRadius: 8,
    maxWidth: 250,
    '&:hover': {
      backgroundColor: theme.palette.green_200.main
    },
    '& span': {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap'
    }
  },

  // =========================================================================
  // ## Tabs
  // =========================================================================

  tab: {
    borderBottom:
      theme.palette.type === 'dark'
        ? `1px solid ${theme.palette.dark_stroke.main}`
        : `1px solid ${theme.palette.gray_stroke.main}`,
    minHeight: '0px !important',
    '& .MuiTab-root': {
      minHeight: '28px',
      minWidth: '110px',
      backgroundColor:
        theme.palette.type === 'dark'
          ? theme.palette.dark_600.main
          : theme.palette.gray_100.main
    },
    '& .MuiTabs-indicator': {
      display: 'none'
    },
    '& .MuiTabScrollButton-root': {
      width: '0px'
    }
  },
  tabHeader: {
    // backgroundColor: theme.palette.blue_300.main,
    borderRadius: '8px 8px 0 0',
    // margin: '12px 0px 0 0',
    padding: '2px 4px',
    position: 'relative',
    zIndex: 1,
    // boxShadow: '0 2px 5px rgba(0,0,0,0.1)',

    '&.Mui-selected': {
      backgroundColor: theme.palette.blue_300.main,
      color: theme.palette.white_100.main,
      zIndex: 2,
      '& span': {
        color: theme.palette.white_100.main
      }
    }
  },
}))
